import React, { useEffect, useState } from "react";
import {
  DEMO_TYPE,
  MONTHLY_TYPE,
  RETAKE_TYPE,
  SLOT_STATUSES,
  STATUS_AVAILABLE,
  STUDENT_ROLE,
  TEACHER_ROLE,
  TEACHING_MODE,
  offerStatuses,
} from "../../constants";
import {
  addDocToFirestore,
  capitalizeFirstLetter,
  formatChatDate,
  formatUtcToLocalTime,
  getOfferTypeColor,
  getStatusColor,
  groupSlotsByDate,
  reactToast,
} from "../../helper";
import PopOverMenu from "../pop-over-menu/pop-over-menu";
import { fetchOfferSlots } from "../../services/teacher";
import { useSelector } from "react-redux";
import {
  fetchOfferSlotsByOfferSlotId,
  updateMeetingSlotStatus,
} from "../../services/offer-slots";
import CreateOfferCard from "../createOfferCard/CreateOfferCard";
import { toast } from "react-toastify";
import SessionActions from "./components/session-actions";
import ReviewModal from "../review-modal";
import {
  BiBook,
  BiCalendar,
  BiMessageSquareDetail,
  BiSolidUserDetail,
} from "react-icons/bi";
import { FaDollarSign } from "react-icons/fa";
import { TbCheckupList, TbDetails } from "react-icons/tb";
import { PiGitDiff } from "react-icons/pi";
import "./style.css";
import { MdModeStandby } from "react-icons/md";
import { Badge, Button, Popover } from "antd";

export const OfferCard = ({
  offerDetail,
  type,
  handleChatModal,
  messageBgColor,
}) => {
  const initReviewAndRating = {
    review: null,
    rating: null,
    slotId: 0,
  };

  const currentUser = useSelector((state) => state.auth.user);
  const [detail, setDetail] = useState();

  const [loading, setLoading] = useState(false);
  const [slotUpdateStatusLoading, setSlotUpdateStatusLoading] = useState(false);
  const [reviewModal, setReviewModal] = useState(false);
  const [reviewAndRatingDetail, setReviewAndRatingDetail] = useState({
    ...initReviewAndRating,
  });

  const [openOfferCard, setOpenOfferCard] = useState(false);

  const [retakeOfferDetail, setRetakeOfferDetail] = useState();
  const [trackDetail, setTrackDetail] = useState();

  const statusStyle = getStatusColor(offerDetail?.status);

  // useEffect(() => {
  //   console.log("detail", detail);
  // }, [detail]);

  useEffect(() => {
    if (offerDetail) {
      setDetail({ ...offerDetail });
      setRetakeOfferDetail({ ...offerDetail });
    }
  }, [offerDetail]);

  // const [newMessage, setNewMessage] = useState("");

  // new Funcitionality to send message
  const sendMessage = async (message, offerData) => {
    try {
      if (message.trim() === "") return;
      setLoading(true);
      // setNewMessage("");
      const userID = currentUser?.uuid;
      const receiverID = retakeOfferDetail?.teacher?.uuid;
      let messageBody = {};

      // is offer type
      if (openOfferCard) {
        messageBody = {
          text: message,
          sender_uuid: userID,
          senderName: currentUser?.fullName,
          receiver_uuid: receiverID,
          // receiverId: receiver?.id,
          // receiverName: receiver?.fullName,
          receiverId: retakeOfferDetail?.teacherId,
          receiverName: retakeOfferDetail?.teacher?.fullName,

          timestamp: new Date().toISOString(),
          seen: false,

          offerDetail: offerData,
        };
      } else {
        messageBody = {
          text: message,
          sender_uuid: userID,
          senderName: currentUser?.fullName,
          senderRole: currentUser?.role || "",
          receiver_uuid: receiverID,
          // receiverId: receiver?.id,
          // receiverName: receiver?.fullName,
          receiverId: retakeOfferDetail?.teacherId,
          receiverName: retakeOfferDetail?.teacher?.fullName,
          timestamp: new Date().toISOString(),
          seen: false,
        };
      }
      // setMessages([messageBody, ...messages]);
      // scrollToBottom();
      // await addDocToFirestore(currentUser?.uuid, receiver?.uuid, messageBody);
      await addDocToFirestore(
        currentUser?.uuid,
        retakeOfferDetail?.teacher?.uuid,
        messageBody
      );

      setLoading(false);
    } catch (error) {
      toast.error("Message is not sent, try again");
      console.error("Error sending message:", error);
      setLoading(false);
    }
  };

  const sendOffer = async (offerData) => {
    try {
      // await sendMessage("New Offer Request", {
      //   ...offerData,
      //   offerStatus: offerStatuses.PENDING,
      // });
      await sendMessage("Retake Offer Request", {
        ...offerData,
        offerStatus: offerStatuses.PENDING,
      });
      if (openOfferCard) {
        handleCreateOfferCardModal(MONTHLY_TYPE);
      }
    } catch (error) {}
  };

  const handleCreateOfferCardModal = (offerType, slots) => {
    setOpenOfferCard(!openOfferCard);
    if (offerType) {
      setRetakeOfferDetail({
        ...retakeOfferDetail,
        offerType,
        retakeSlotId: slots[0]?.id,
      });
    }

    // else {
    //   setRetakeOfferDetail({ ...retakeOfferDetail });
    // }
  };

  const getOfferSlots = async (teacherId, offerId) => {
    try {
      setLoading(true);
      const { data, status } = await fetchOfferSlots(teacherId, offerId);
      if (status === 200) {
        if (data?.data?.length) {
          setDetail((prev) => ({
            ...prev,
            slots: data?.data,
          }));
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getTrackDetail = async (offerSlotID) => {
    try {
      setLoading(true);
      const { data, status } = await fetchOfferSlotsByOfferSlotId(offerSlotID);
      if (status === 200) {
        setTrackDetail(data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const reviewAndRating = (offer, slot) => {
    setReviewAndRatingDetail((preState) => ({
      ...preState,
      slotId: slot?.id,
    }));
    setReviewModal(true);
  };

  const handleCanclereviewModal = () => {
    let temp = { ...reviewAndRatingDetail };
    temp.rating = null;
    temp.review = null;
    setReviewAndRatingDetail(temp);
    // setReviewAndRatingDetail(preState => ({
    //   ...preState,
    //   review: null,
    //   rating: null,
    // }))
    setReviewModal(false);
    // handleReviewAndRatingSubmit(temp)
  };

  useEffect(() => {}, [reviewAndRatingDetail]);

  const handleReviewAndRatingSubmit = async (reviewDetail) => {
    setReviewModal(false);

    try {
      setSlotUpdateStatusLoading(true);
      let payload = {
        status: SLOT_STATUSES.COMPLETED,
        review: reviewDetail.review,
        rating: reviewDetail.rating,
        teacherId: offerDetail?.teacherId,
      };
      const { data, status } = await updateMeetingSlotStatus(
        reviewDetail.slotId,
        payload
      );
      if (status === 200) {
        reactToast("success", data?.message);
        let temp = { ...detail };
        let findSlot = temp?.slots?.find(
          (item) => Number(item?.id) === Number(reviewDetail.slotId)
        );
        if (findSlot) {
          findSlot.status = SLOT_STATUSES.COMPLETED;
          setDetail(temp);
        }
        // await getOfferSlots(offer?.teacherId, offer?.id);
      } else {
        reactToast("error", data?.message);
      }
      setSlotUpdateStatusLoading(false);
      setReviewAndRatingDetail({ ...initReviewAndRating });
    } catch (error) {
      setSlotUpdateStatusLoading(false);
    }
  };

  // unused
  const updateSlotStatus = async (offer, slot) => {
    try {
      setSlotUpdateStatusLoading(true);
      let payload = {
        status: SLOT_STATUSES.COMPLETED,
      };
      const { data, status } = await updateMeetingSlotStatus(slot?.id, payload);
      if (status === 200) {
        reactToast("success", data?.message);
        let temp = { ...detail };
        let findSlot = temp?.slots?.find(
          (item) => Number(item?.id) === Number(slot?.id)
        );
        if (findSlot) {
          findSlot.status = SLOT_STATUSES.COMPLETED;
          setDetail(temp);
        }
        // await getOfferSlots(offer?.teacherId, offer?.id);
      } else {
        reactToast("error", data?.message);
      }
      setSlotUpdateStatusLoading(false);
    } catch (error) {
      setSlotUpdateStatusLoading(false);
    }
  };

  const renderSlots = (slots) => {
    if (loading) return "Loading...";
    if (!slots) return "No slots available";

    const renderSlotDetails = Object.entries(groupSlotsByDate(slots))?.map(
      ([date, slots]) => {
        return (
          <div key={date} className="py-1">
            <b>
              <span className="d-block poppins">
                {" "}
                {`${date} - ${slots[0]?.dayName}`} {`(${slots?.length})`}
              </span>
            </b>
            <SlotList slots={slots} />
          </div>
        );
      }
    );

    return (
      <div
        style={{
          minHeight: "100px",
          maxHeight: "300px",
          // overflowY: "scroll",
          // padding: "0px 10px",
        }}
      >
        <div>
          <b>
            Total Days:{" "}
            {`(${Object.entries(groupSlotsByDate(detail?.slots))?.length})`}
          </b>
        </div>
        {renderSlotDetails}
      </div>
    );
  };

  const renderTrackDetail = () => {
    if (loading) return "Loading...";

    const details = (
      <div className="mt-2 fs_12">
        <div>
          <b>Offer Type:</b> {trackDetail?.offer?.offerType}
        </div>
        <div>
          <b>Teaching Mode:</b> {trackDetail?.offer?.teachingMode}
        </div>
        <div>
          <b>Date:</b> {trackDetail?.date}
        </div>
        <div>
          <b>Price:</b> {trackDetail?.offer?.price}
        </div>
        <div>
          <b>Subjects Requested: </b>
          {trackDetail?.offer?.offerSubjects.length
            ? trackDetail?.offer?.offerSubjects?.map((cur, i) =>
                i === trackDetail?.offer?.offerSubjects.length - 1 ? (
                  <span key={i}>{cur?.subjectName}</span>
                ) : (
                  <span key={i}>{cur?.subjectName},</span>
                )
              )
            : "-"}
        </div>
      </div>
    );

    return (
      <div
        style={{
          minHeight: "100px",
          maxHeight: "300px",
          // overflowY: "scroll",
          padding: "0px 10px",
        }}
      >
        <div>
          <u>
            <b>Details: </b>
          </u>
        </div>
        {details}
      </div>
    );
    // });
  };

  const SlotList = ({ slots }) => (
    <p className="ps-3 slot-item align-items-center mx-1">
      {slots.map((slot) => (
        <li key={slot.uuid}>
          <span className="d-block">
            {slot?.status && (
              <Badge
                status={
                  slot.status === STATUS_AVAILABLE
                    ? "success"
                    : slot.status === SLOT_STATUSES.COMPLETED
                    ? "success"
                    : slot.status === SLOT_STATUSES.DELIVERED
                    ? "warning"
                    : "error"
                }
                text={
                  <span className="text-capitalize poppins status-text">
                    {slot?.status}
                  </span>
                }
              />
            )}

            <span
              className="d-inline-block poppins"
              style={{ minWidth: "135px" }}
            >
              {`${formatUtcToLocalTime(
                slot?.startTime
              )} - ${formatUtcToLocalTime(slot?.endTime)}`}
            </span>
          </span>
          {currentUser?.role === STUDENT_ROLE &&
          offerDetail?.status === offerStatuses.ACCEPTED &&
          slot?.status !== SLOT_STATUSES.COMPLETED &&
          slot?.status === SLOT_STATUSES.DELIVERED ? (
            // true
            <SessionActions
              slot={slot}
              offerDetail={offerDetail}
              slotUpdateStatusLoading={slotUpdateStatusLoading}
              reviewAndRating={reviewAndRating}
              handleCreateOfferCardModal={handleCreateOfferCardModal}
              RETAKE_TYPE={RETAKE_TYPE}
            />
          ) : (
            ""
          )}
          {currentUser?.role === TEACHER_ROLE &&
          offerDetail?.status === offerStatuses.ACCEPTED &&
          slot?.status !== SLOT_STATUSES.COMPLETED &&
          slot?.status === SLOT_STATUSES.DELIVERED ? (
            <span className="text-danger">Not yet completed by Student</span>
          ) : (
            ""
          )}
        </li>
      ))}
    </p>
  );

  const getPopoverContent = (slots) => {
      return (
        <div className={"popover-content"}>{renderSlots(slots)}</div>
      );
    };

  const textColor = type !== "OFFER" && "text-dark";
  const iconClass = type !== "OFFER" ? "text-dark" : "text-muted";
/*   const textColor = type !== "OFFER" && "text-white";
  const iconClass = type !== "OFFER" ? "text-white" : "text-muted"; */

  return (
    <>
      {/* offer card modal */}
      <CreateOfferCard
        // zIndex={10000}
        open={openOfferCard}
        setOfferDetail={setRetakeOfferDetail}
        offerDetail={retakeOfferDetail}
        // when offer will send by student
        teacherId={retakeOfferDetail?.teacherId}
        studentId={currentUser?.id}
        onSendOffer={sendOffer}
        handleOk={handleCreateOfferCardModal}
        handleCancel={handleCreateOfferCardModal}
      />

      {reviewModal && (
        <ReviewModal
          show={reviewModal}
          onCancel={handleCanclereviewModal}
          onSubmit={handleReviewAndRatingSubmit}
          loading={loading}
          reviewAndRatingDetail={reviewAndRatingDetail}
          setReviewAndRatingDetail={setReviewAndRatingDetail}
        />
      )}

      {/* will be only shown in offer cards, not in message chat */}
      {type === "OFFER" && (
        <div className="card-header border-bottom pb-3">
          <div className="d-flex justify-content-between align-items-center mb-2 w-100">
            <h5 className="card-title mb-0 poppins">
              {currentUser?.role === TEACHER_ROLE
                ? detail?.student?.fullName
                : detail?.teacher?.fullName}
            </h5>
            <span
              className="status-badge poppins"
              style={{
                backgroundColor: statusStyle.bg,
                color: statusStyle.text,
              }}
            >
              {capitalizeFirstLetter(detail?.status)}
            </span>
          </div>

          <div className="d-flex gap-2 flex-wrap">
            <span
              className="feature-badge poppins"
              style={{
                backgroundColor: getOfferTypeColor(detail?.offerType).bg,
                color: getOfferTypeColor(detail?.offerType).text,
                borderColor: getOfferTypeColor(detail?.offerType).border,
              }}
            >
              {capitalizeFirstLetter(detail?.offerType)}
            </span>
            <span
              className="feature-badge poppins"
              style={{
                backgroundColor: "rgba(108, 117, 125, 0.1)",
                color: "#6c757d",
              }}
            >
              {capitalizeFirstLetter(detail?.teachingMode)}
            </span>
          </div>
        </div>
      )}

      <div
        className="card-body"
        style={{
          backgroundColor: type !== "OFFER" ? messageBgColor : "",
          marginTop: type !== "OFFER" && "10px",
        }}
      >
        <div className="info-section mb-3">
          {type !== "OFFER" && (
            <>
              <div className="detail-item">
                <PiGitDiff size={16} className={`icon ${iconClass}`} />
                <span className={`fs-12 poppins ${textColor}`}>
                  Offer type :
                </span>
                <span className="value">
                  {capitalizeFirstLetter(
                    detail?.instantOffer ? "Instant Offer" : detail?.offerType
                  )}
                </span>
              </div>
              <div className="detail-item">
                <MdModeStandby size={16} className={`icon ${iconClass}`} />
                <span className={`fs-12 poppins ${textColor}`}>
                  Teaching mode :
                </span>
                <span className="value">
                  {capitalizeFirstLetter(detail?.teachingMode)}
                </span>
              </div>
            </>
          )}
          <div className="detail-item">
            <BiCalendar size={16} className={`icon ${iconClass}`} />
            <span className={`fs-12 ${textColor}`}>
              {detail?.offerType === MONTHLY_TYPE ? "Duration :" : "Date :"}
            </span>
            <span className="value">
              {detail?.offerType === MONTHLY_TYPE
                ? `${formatChatDate(detail?.startDate)} - ${formatChatDate(
                    detail?.endDate
                  )}`
                : formatChatDate(detail?.startDate)}
            </span>
          </div>
          <div className="detail-item">
            <FaDollarSign size={16} className={`icon ${iconClass}`} />
            <span className={`fs-12 ${textColor}`}>Price :</span>
            <span className="value fw-medium poppins">PKR {detail?.price}</span>
          </div>

          {detail?.subjects?.length > 0 && (
            <div className="mb-2">
              <div className="subject-header">
                <BiBook size={16} className={`icon me-2 ${iconClass}`} />
                <span
                  className={`small fs-12${
                    type === "OFFER" ? "text-muted" : "text-dark"
                  }`}
                >
                  Requested Subjects :
                </span>
              </div>
              <div className="subject-tags">
                {detail?.subjects?.map((subject, index) => (
                  <div
                    key={index}
                    style={{ fontSize: "0.75rem" }}
                    className="d-flex justify-content-between align-items-center ps-1 w-100 mt-1"
                  >
                    <span
                      className={`fs-12 ${
                        type === "OFFER" ? "text-primary" : "text-dark"
                      }`}
                    >
                      {subject.subjectName}
                    </span>
                    <span
                      className={` fs-12${
                        type === "OFFER" ? "text-secondary" : "text-dark"
                      }`}
                    >
                      {subject.levelName}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {detail?.extraSubjects.length > 0 && (
            <div>
              <div className="subject-header">
                <BiBook size={16} className={`icon me-2 ${iconClass}`} />
                <span className={`small ${textColor}`}>Other Subjects</span>
              </div>
              <div className="subject-tags" style={{ fontSize: "0.75rem" }}>
                {detail?.extraSubjects.map((subject, index) => (
                  <span
                    key={index}
                    className={`${
                      type !== "OFFER" ? `${textColor}` : "subject-tag other"
                    }`}
                  >
                    {subject?.subjectName}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className="card-footer pt-2 d-flex justify-content-between align-items-center"
        style={{
          backgroundColor: type !== "OFFER" ? messageBgColor : "",
        }}
      >
        <div className="d-flex gap-1">
          {/* 
          {detail?.slots?.length && (
            <PopOverMenu
              placement="bottom"
              // render slots here
              content={<>{renderSlots(detail?.slots)}</>}
              button={
                <button
                  className={`${
                    type !== "OFFER" ? "px-0 btn" : "btn btn-icon"
                  }`}
                  aria-label="slots"
                >
                  <TbCheckupList
                    size={22}
                    className={`icon ${
                      type !== "OFFER" ? `${textColor} px-0` : "text-muted"
                    }`}
                    onClick={() => {
                      getOfferSlots(offerDetail?.teacherId, offerDetail?.id);
                    }}
                  />
                </button>
              }
            />
          )}
           */}
          {detail?.slots?.length ? (
            <Popover
              content={getPopoverContent(detail?.slots)}
              // title="Slots Details"
              placement="bottom"
              trigger="click"
              overlayClassName={"slots-popover"}
            >
              <Button
                type="text"
                className={`${type !== "OFFER" ? "px-0 btn" : "btn btn-icon"}`}
                aria-label="slots"
                style={{ padding: "0px" }}
              >
                <TbCheckupList
                  size={22}
                  className={`icon ${
                    type !== "OFFER" ? `${textColor} px-0` : "text-muted"
                  }`}
                  onClick={() => {
                    getOfferSlots(offerDetail?.teacherId, offerDetail?.id);
                  }}
                />
              </Button>
            </Popover>
          ) : null}
          {detail?.description?.length ? (
            <Popover
              overlayClassName={"description-popover"}
              content={
                <div
                  style={{
                    minHeight: "100px",
                    maxHeight: "300px",
                    // overflowY: "scroll",
                    padding: "0px 10px",
                  }}
                >
                  <div>
                    <b className="poppins">Description</b>
                  </div>
                  <span className="poppins">{detail?.description}</span>
                </div>
              }
              placement="bottom"
              trigger="click"
            >
              <Button
                className={`${type !== "OFFER" ? "px-0 btn" : "btn btn-icon"}`}
                type="text"
                aria-label="description"
                style={{ padding: "0px" }}
              >
                <BiSolidUserDetail
                  size={22}
                  className={`icon ${
                    type !== "OFFER" ? `${textColor} px-0` : "text-muted"
                  }`}
                />
              </Button>
            </Popover>
          ) : null}
          {detail?.offerType === RETAKE_TYPE ? (
            <PopOverMenu
              placement="bottom"
              // render track details
              content={<>{renderTrackDetail()}</>}
              button={
                <button className="btn btn-icon" aria-label="track">
                  <TbDetails
                    size={22}
                    className="icon text-muted"
                    onClick={() => {
                      getTrackDetail(detail?.offerSlots[0]?.offerSlotId);
                    }}
                  />
                </button>
              }
            />
          ) : null}
        </div>

        {type === "OFFER" && (
          <div className="d-flex gap-1">
            <button
              className="btn btn-icon"
              aria-label="Message"
              type="button"
              onClick={() => handleChatModal(true, offerDetail)}
            >
              <BiMessageSquareDetail size={22} className="text-primary" />
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default OfferCard;
